import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";
import { QuestionnaireNotice } from "./QuestionnaireNotice";

class QuestionnaireNoticeTableItem implements ITableDataSourceItem<QuestionnaireNotice> {
    public Model: QuestionnaireNotice;
    public IsSelected: boolean;
    public Name: string;

    constructor(model: QuestionnaireNotice) {
        this.Model = model;
        this.IsSelected = false;
    }
}

export { QuestionnaireNoticeTableItem };
